export const APP_VERSION = 'v1.16';
